import React from "react";
import { useTranslation } from "react-i18next";
import Icon from "../../../../../common/components/Icon/Icon";
import { DeliveryEstimation } from "../../types/productApiTypes";

interface Props {
  /** The estimation data from the product or cart. */
  estimate?: DeliveryEstimation;
  /** Optional class for additional styling. */
  className?: string;
}

/**
 * A standardized block displaying the delivery window.
 * Used across the entire theme for consistent logistics communication.
 */
const DeliveryEstimateDisplay: React.FC<Props> = ({
  estimate,
  className = "",
}) => {
  const { t } = useTranslation();

  if (!estimate) return null;

  const rootClass = `delivery-estimate ${className}`.trim();

  return (
    <div className={rootClass}>
      <div className="delivery-estimate__icon-box">
        <Icon
          iconName="truck"
          className="delivery-estimate__icon icon--stroke-thick"
        />
      </div>
      <div className="delivery-estimate__content">
        <span className="delivery-estimate__label">
          {t("delivery.estimateLabel", "Estimated Delivery")}
        </span>
        <span className="delivery-estimate__date">
          {estimate.displayString}
        </span>
        <span className="delivery-estimate__disclaimer">
          {t("delivery.disclaimer", "Final dates are calculated at checkout.")}
        </span>
      </div>
    </div>
  );
};

export default DeliveryEstimateDisplay;
